module.exports = __webpack_public_path__ + "img/39000.8d738820.jpg";